import { DateTime } from 'luxon';

const timeZone = DateTime.now().zone;
const dateParse = (value: string) => {
  if (value === '') return undefined;
  return DateTime.fromFormat(value, "yyyy-MM-dd'T'HH:mm").setZone(timeZone).toISO();
};
export const dateFormat = (value: string | undefined) => {
  if (!value) return '';
  return DateTime.fromISO(value).toFormat("yyyy-MM-dd'T'HH:mm");
};

export default dateParse;
